import { render, staticRenderFns } from "./email-login.vue?vue&type=template&id=75b620a8&scoped=true"
import script from "./email-login.vue?vue&type=script&lang=ts"
export * from "./email-login.vue?vue&type=script&lang=ts"
import style0 from "./email-login.vue?vue&type=style&index=0&id=75b620a8&lang=scss"
import style1 from "./email-login.vue?vue&type=style&index=1&id=75b620a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b620a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75b620a8')) {
      api.createRecord('75b620a8', component.options)
    } else {
      api.reload('75b620a8', component.options)
    }
    module.hot.accept("./email-login.vue?vue&type=template&id=75b620a8&scoped=true", function () {
      api.rerender('75b620a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/email-login.vue"
export default component.exports